/* lua.js generated code undefined */

require("clover/logic/UserEnergy")
let UserLevelTypeBase = require("clover/logic/userLevel/UserLevelTypeBase")
let UserLevelTypeMysteryIslandLevel = xClass("UserLevelTypeMysteryIslandLevel", UserLevelTypeBase)
UserLevelTypeMysteryIslandLevel.prototype.canStartLevel = function (levelId, itemList, islandPrivilege) {
    let self = this
    let mainLevelId = MysteryIslandManager.getInstance().calculateMainLevelId(levelId)
    let levelType = LevelType.getLevelTypeByLevelId(mainLevelId)
    if (levelType !== GameLevelType.kMainLevel && levelType !== GameLevelType.kEditor) {
    //     // FIXME: multi result
        return [false, ZooErrorCode.LEVEL_ID_INVALID]
    }
    // // WARN: maybe multi result
    return UserLevel.getInstance().canStartLevel(mainLevelId, itemList, islandPrivilege)
    // return [true,0]
}
UserLevelTypeMysteryIslandLevel.prototype.ctor = function (levelId, itemList) {
    let self = this
    UserLevelTypeBase.prototype.ctor.call(self, levelId, itemList)
    self.levelType = GameLevelType.kMysteryIsland
}
UserLevelTypeMysteryIslandLevel.prototype.startLevel = function (levelId, itemList, successCallback, failCallback, cancelCallback) {
    var self = this
    // var consumeEnergy = self.getConsumeEnergy(levelId)
    function onSuccess(event) {
        // UserEnergy.getInstance().unlockEnergy(consumeEnergy)
        // UserEnergy.getInstance().consumeEnergy(consumeEnergy)
        if (successCallback) {
            successCallback(event)
        }
    }
    function onFail(event) {
        // UserEnergy.getInstance().unlockEnergy(consumeEnergy)
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        // UserEnergy.getInstance().unlockEnergy(consumeEnergy)
        if (cancelCallback) {
            cancelCallback()
        }
    }
//    这里判断当前最大关是否和登录一致 不一致提示玩家登录体验最新关卡


    if ( UserManager.getInstance().getIsOpenNewLevel()){
        onFail({data:"open_new_max_level"})//重新定义个错误码提示玩家重新登录体验最新关卡
    }else{
        onSuccess()
        // onFail({data:301})
    }
}
UserLevelTypeMysteryIslandLevel.prototype.canUseProp = function (propId, num) {
    var self = this
    var [success, errCode] = UserLevelTypeBase.prototype.canUseProp_checkRange.call(self, propId)
    if (!success) {
        return [success, errCode]
    }
    var [success, errCode] = UserLevelTypeBase.prototype.canUseProp_checkUseTime.call(self, propId, num)
    if (!success) {
        return [success, errCode]
    }
    return [true]
}
UserLevelTypeMysteryIslandLevel.prototype.endLevel = function (score, star, stageTime, coin, targetCount, opLog, costMove, replay, successCallback, failCallback, cancelCallback, otherData) {
    var self = this
    otherData = otherData || {}
    function buildrewardList(event) {

        var rewardList = ((event || table()).data || table()).rewardItems || table()
        if ($len(rewardList) > 0) {
            for (var i = 1, v = rewardList[1]; v; i++, v = rewardList[i]) {
                UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.STAGE_REWARD)
            }
        }

    }

    function onSuccess(event) {
        buildrewardList(event)
        if (event.data.extra.goldElysiumRobotList){
            GoldElysiumManager.getInstance().getData().updateInfo({
                winningStreak: event.data.extra.goldElysiumWinningStreak,
                survivalList: event.data.extra.goldElysiumRobotList,
                winnerList: event.data.extra.goldElysiumWinnerList,
            })
            GoldElysiumManager.getInstance().dcGoldElysiumChangeResult(star > 0,otherData.src || "fail",self.levelId)
        }
        if (successCallback) {
            successCallback(event)
        }
    }
    function onFail(event) {
        buildrewardList(event)        
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        if (cancelCallback) {
            cancelCallback(event)
        }
    }
    self.sendEndRequest(score, star, stageTime, coin, targetCount, opLog, costMove, replay, onSuccess, onFail, onCancel, otherData)
}


UserLevelTypeMysteryIslandLevel.prototype.getConsumeEnergy = function (levelId,vague) {
    var self = this
    //console.log("[monthticket] UserLevelTypeMysteryIslandLevel")
    var consume = MetaManager.getInstance().global.user_energy_level_consume || 5
    // if (UserManager.getInstance().isHaveEquityMonthTicket(vague)){
    //     consume = 4
    // }
    return consume
}
module.exports = UserLevelTypeMysteryIslandLevel
